module Meevo.Plugins.AlertsManager {
    import IAlertJSON = Meevo.Model.IAlertJSON;

    interface ISingleMoverAlertJson extends IAlertJSON {
        [key: string]: any;
    }

    class SmartMoverConfig extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            '$translate',
        ];

        public params: IParams;
        public data: ISingleMoverData;

        public selectedItems: any[] = [];
        public selectedCategories: any[] = [];
        public isAllSelected: boolean = true;
        public defaultFilterValue: any;

        get dataForReview() {
            return (this.isAllSelected && !this.data.useAllItemsAsSelected)
                ? [this.$translate.instant('LABEL_ALL')]
                : (this.selectedItems || []).map((item) => item.displayName);
        }

        get alertConfiguration() {
            if (!!this.data.allConfigKey) {
                return {
                    [this.data.configKey]: (this.selectedItems || []).map((item) => item.id),
                    [this.data.allConfigKey]: this.isAllSelected,
                    defaultFilterValue: this.defaultFilterValue,
                };
            }

            return {
                [this.data.configKey]: (this.selectedItems || []).map((item) => item.id),
            };
        }

        constructor(protected alertsManagerService: IAlertsManagerService,
                    protected $translate: ng.translate.ITranslateService) {
            super(alertsManagerService);

            if (angular.isDefined(this.data.allSelected)) {
                this.isAllSelected = this.data.allSelected;
            } else {
                this.isAllSelected = true;
            }
        }

        onEdit(alertJSON: ISingleMoverAlertJson): void {
            this.selectedItems = (alertJSON[this.data.configKey] || []);
            this.defaultFilterValue = alertJSON.defaultFilterValue;
            if (!!this.data.allConfigKey) {
                this.isAllSelected = alertJSON[this.data.allConfigKey];
            }
        }

        onMoverFilterChanged(values: any) {
            this.defaultFilterValue = values;
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoAlertSmartMoverConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/smart-mover-config/smart-mover-config.html',
            controller: SmartMoverConfig,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        });
}
